<div class="logo"
     [ngClass]="{
         'vertical': type() === 'vertical',
         'horizontal': type() === 'horizontal'
     }"
     [woa-css-var]="{
         '--woa-horizontal-logo-height': px(orderingContextModel.horizontalLogoHeightPx()),
         '--woa-vertical-logo-width': px(orderingContextModel.verticalLogoWidthPx())
     }">
    @if (configurationModel.isWaiterActor()) {
        <woa-chewzie-logo class="logo-chewzie" [type]="type()" [engage]="false"></woa-chewzie-logo>
    }
    @if (showVerticalLogo()) {
        @if (orderingContextModel.verticalLogoImageSvg()) {
            <img class="logo-image" [src]="'data:image/svg+xml;base64,' + orderingContextModel.verticalLogoImage() | url">
        } @else if (orderingContextModel.verticalLogoImage()) {
            <!--suppress AngularNgOptimizedImage, HtmlRequiredAltAttribute -->
            <img class="logo-image" [src]="'data:image/png;base64,' + orderingContextModel.verticalLogoImage() | url">
        }
    }
    @if (showHorizontalLogo()) {
        @if (orderingContextModel.horizontalLogoImageSvg()) {
            <img class="logo-image" [src]="'data:image/svg+xml;base64,' + orderingContextModel.horizontalLogoImage() | url">
        } @else if (orderingContextModel.horizontalLogoImage()) {
            <!--suppress AngularNgOptimizedImage, HtmlRequiredAltAttribute -->
            <img class="logo-image" [src]="'data:image/png;base64,' + orderingContextModel.horizontalLogoImage() | url">
        }
    }
</div>
